import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { ProgressBar } from 'primereact/progressbar';
import axios from 'axios';

const PartnerShowComponent = (props) => {
  const { t } = props;
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});

  const apiCall = (method, url, data) => {
    return axios({
      method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('userToken'),
        'App-Network': localStorage.getItem('networkId'),
      },
    });
  };

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    apiCall('get', `/api/v2/partner/${id}`)
      .then((res) => {
        setFormData(res.data.data || {})
        props.onLoaded(res.data.data || {});
      })
      .catch((error) => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => setLoading(false));
  }, [id, window.App?.state?.rerenderPartnerList]);

  const typeLabel = (() => {
    switch (formData?.type) {
      case 'PERSON':
        return t('person');
      case 'ORGANISATION':
        return t('organisation');
      case 'OTHER':
        return t('other');
      default:
        return '';
    }
  })();

  return (
    <div className="partner-show widget">
      {loading && (
        <ProgressBar
          mode="indeterminate"
          style={{ height: '5px', position: 'absolute', top: 0, left: 0, borderRadius: 0 }}
        />
      )}
      <div className="p-grid">
        <div className="p-col-12 p-lg-6">
          <div className="p-field p-fluid">
            <label htmlFor="name">{t('columnName2')}</label>
            <span className="p-d-block fake-input">{formData?.name}</span>
          </div>
        </div>
        <div className="p-col-12 p-lg-6">
          <div className="p-field p-fluid">
            <label htmlFor="type">{t('columnType')}</label>
            <span className="p-d-block fake-input">{typeLabel}</span>
          </div>
        </div>

      </div>
      <div className="p-grid p-mt-1">
        <div className="p-col-12">
          <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
            <i className="pi pi-map-marker" />{' '}
            {formData?.type === 'PERSON' ? t('residentialAddress') : formData?.type === 'ORGANISATION' ? t('headquartersAddress') : t('addressSection')}
          </h3>
        </div>
      </div>
      <div className="p-grid">
        <div className="p-col-12 p-md-3 p-lg-3">
          <div className="p-field p-fluid">
            <label>{t('columnCountry')}</label>
            <span className="p-d-block fake-input">{formData?.address_country_code}</span>
          </div>
        </div>
        <div className="p-col-12 p-md-2 p-lg-2">
          <div className="p-field p-fluid">
            <label>{t('columnPostalCode')}</label>
            <span className="p-d-block fake-input">{formData?.address_postal_code}</span>
          </div>
        </div>
        <div className="p-col-12 p-md-3 p-lg-3">
          <div className="p-field p-fluid">
            <label>{t('columnCity')}</label>
            <span className="p-d-block fake-input">{formData?.address_city}</span>
          </div>
        </div>
        <div className="p-col-12 p-md-4 p-lg-4">
          <div className="p-field p-fluid">
            <label>{t('columnAddress')}</label>
            <span className="p-d-block fake-input">{formData?.address_detail}</span>
          </div>
        </div>
      </div>
      {true && (
        <>
          <div className="p-grid p-mt-1">
            <div className="p-col-12">
              <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                <i className="pi pi-file" /> {t('identifiers')}
              </h3>
            </div>
          </div>
          <div className="p-grid">
            <div className="p-col-12 p-md-4 p-lg-4">
              <div className="p-field p-fluid">
                <label>{t('columnTaxNumber')}</label>
                <span className="p-d-block fake-input">{formData?.vat_number}</span>
              </div>
            </div>
            <div className="p-col-12 p-md-4 p-lg-4">
              <div className="p-field p-fluid">
                <label>{t('fieldCommunityVatNumber')}</label>
                <span className="p-d-block fake-input">{formData?.community_vat_number}</span>
              </div>
            </div>
            <div className="p-col-12 p-md-4 p-lg-4">
              <div className="p-field p-fluid">
                <label>{t('fieldGroupVatNumber')}</label>
                <span className="p-d-block fake-input">{formData?.group_vat_number}</span>
              </div>
            </div>
            <div className="p-col-12 p-md-4 p-lg-4">
              <div className="p-field p-fluid">
                <label>{t('fieldOther')}</label>
                <span className="p-d-block fake-input">{formData?.other}</span>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="p-grid p-mt-1">
        <div className="p-col-12">
          <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
            <i className="pi pi-phone" /> {t('centralContact')}
          </h3>
        </div>
      </div>
      <div className="p-grid">
        <div className="p-col-12 p-lg-6">
          <div className="p-field p-fluid">
            <label>{t('columnPhone')}</label>
            <span className="p-d-block fake-input">{formData?.phone}</span>
          </div>
        </div>
        <div className="p-col-12 p-lg-6">
          <div className="p-field p-fluid">
            <label>{t('columnEmail')}</label>
            <span className="p-d-block fake-input">{formData?.email}</span>
          </div>
        </div>
        <div className="p-col-12">
          <div className="p-field p-fluid">
            <label>{t('columnComment')}</label>
            <span className="p-d-block fake-input">{formData?.note}</span>
          </div>
        </div>
      </div>
      <div className="p-grid p-mt-1">
        <div className="p-col-12">
          <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
            <i className="pi pi-info-circle" /> {t('properties')}
          </h3>
        </div>
      </div>
      <div className="p-grid">
        <div className="p-col-12 p-md-6 p-lg-6">
          <div className="p-field p-fluid">
            <label>{t('columnActive')}</label>
            <span className="p-d-block fake-input">
              {formData?.active ? <i className="pi pi-check text-success" /> : <i className="pi pi-times text-danger" />}
            </span>
          </div>
        </div>
          <div className="p-col-12 p-lg-6">
              <div className="p-field p-fluid">
                  <label htmlFor="type">{t('columnPaymentDeadline')}</label>
                  <span className="p-d-block fake-input">{formData?.payment_due_days ?? null} {t('day')}</span>
              </div>
          </div>
        <div className="p-col-12 p-md-6 p-lg-6">
          <div className="p-field p-fluid">
            <label>{t('columnCustomer2')}</label>
            <span className="p-d-block fake-input">
              {formData?.customer ? <i className="pi pi-check text-success" /> : <i className="pi pi-times text-danger" />}
            </span>
          </div>
        </div>
      </div>
      <div className="p-grid">
        <div className="p-col-12 p-md-6 p-lg-6">
          <div className="p-field p-fluid">
            <label>{t('columnSupplierService')}</label>
            <span className="p-d-block fake-input">
              {formData?.vendor_service ? <i className="pi pi-check text-success" /> : <i className="pi pi-times text-danger" />}
            </span>
          </div>
        </div>
        <div className="p-col-12 p-md-6 p-lg-6">
          <div className="p-field p-fluid">
            <label>{t('columnSupplierMaterial')}</label>
            <span className="p-d-block fake-input">
              {formData?.vendor_material ? <i className="pi pi-check text-success" /> : <i className="pi pi-times text-danger" />}
            </span>
          </div>
        </div>
      </div>
      <div className="p-grid p-mt-1">
        <div className="p-col-12 p-lg-6">
          <div className="p-field p-fluid">
            <label>{t('columnCreatedAt')}</label>
            <span className="p-d-block fake-input">
              {formData?.created_at &&
                window.App.formatDateValue(formData.created_at)}
            </span>
          </div>
        </div>
        <div className="p-col-12 p-lg-6">
          <div className="p-field p-fluid">
            <label>{t('columnUpdatedAt')}</label>
            <span className="p-d-block fake-input">
              {formData?.updated_at &&
                window.App.formatDateValue(formData.updated_at)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation('common')(PartnerShowComponent);
